import { CARGO } from './cargoPlan';

export interface CargoStyle {
  readonly length: number;
  readonly speed: number;
  readonly pauseS: number;
  readonly phase: number;
  readonly load: number;
}

export function cargoStyle(index: number): CargoStyle {
  return {
    length: CARGO.lengths[index % CARGO.lengths.length]!,
    speed: CARGO.speed * (0.85 + 0.06 * (index % 5)),
    pauseS: 5 + (index % 5),
    phase: (Math.imul(index + 1, 2654435761) >>> 0) / 2 ** 32,
    load: index % 4,
  };
}

/** Acceleration and braking keep a delivery from starting or ending with a sudden stride. */
export function cargoMotionAt(
  length: number,
  style: CargoStyle,
  seconds: number
): { distance: number; speed: number; moving: boolean } {
  const ramp = 1.2;
  const half = length / 2;
  const travel = half / style.speed + ramp;
  const leg = travel + style.pauseS;
  const period = leg * 2;
  const elapsed = seconds + style.phase * period;
  const cycle = Math.floor(elapsed / period);
  const clock = elapsed - cycle * period;
  const outbound = clock < leg;
  const time = outbound ? clock : clock - leg;
  let distance = half;
  let speed = 0;
  if (time < ramp) {
    speed = (style.speed * time) / ramp;
    distance = (style.speed * time * time) / (2 * ramp);
  } else if (time < travel - ramp) {
    speed = style.speed;
    distance = speed * (time - ramp / 2);
  } else if (time < travel) {
    const remaining = travel - time;
    speed = (style.speed * remaining) / ramp;
    distance = half - (style.speed * remaining * remaining) / (2 * ramp);
  }
  return {
    distance: cycle * length + (outbound ? 0 : half) + distance,
    speed,
    moving: speed > 0.001,
  };
}
